export default {
  PRE_PRIMARY: {
    PE: "體能與健康",
    LANGUAGE: "語文",
    MATHS: "早期數學",
    SCIENCE: "科學與科技",
    SOCIETY: "個人與群體",
    ARTS: "藝術",
  },
  PRIMARY: {
    CHINESE: "中國語文教育",
    ENGLISH: "英國語文教育",
    MATHS: "數學教育",
    SOCIETY: "小學常識科：個人、社會及人文教育",
    SCIENCE: "小學常識科：科學教育",
    TECHNOLOGY: "小學常識科：科技教育",
    ARTS: "藝術教育",
    PE: "體育",
    CIVIC: "德育及公民教育",
    READING: "從閱讀中學習",
  },
  SECONDARY: {
    CHINESE: "中國語文教育",
    ENGLISH: "英國語文教育",
    MATHS: "數學教育",
    BIOLOGY: "科學教育：生物",
    CHEMISTRY: "科學教育：化學",
    PHYSICS: "科學教育：物理",
    IS: "科學教育：綜合科學",
    CS: "科學教育：組合科學",
    TECHNOLOGY: "科技教育",
    BUSINESS: "科技教育：企業、會計與財務概論",
    CHINESE_HISTORY: "個人、社會及人文教育：中國歷史",
    ECONOMICS: "個人、社會及人文教育：經濟",
    RELIGION: "個人、社會及人文教育：宗教教育 /倫理與宗教",
    GEOGRAPHY: "個人、社會及人文教育：地理",
    HISTORY: "個人、社會及人文教育：歷史與文化 / 歷史",
    SOCIETY: "個人、社會及人文教育：生活與社會",
    HUMANITIES: "個人、社會及人文教育：綜合人文",
    TOURISM: "個人、社會及人文教育：旅遊與旅遊業",
    MUSIC: "藝術教育：音樂",
    ARTS: "藝術教育：視覺藝術",
    PE: "體育",
    LIBERAL: "通識教育科",
    READING: "從閱讀中學習",
    OTHERS: "其他學習經歷",
    APPLIED: "應用學習",
  },
  TERTIARY: {},
  SPECIAL: {
    BASIC: {
      CHINESE: "(BEC) 中國語文教育",
      ENGLISH: "(BEC) 英國語文教育",
      MATHS: "(BEC) 數學教育",
      SOCIETY: "(BEC) 小學常識科：個人、社會及人文教育",
      SCIENCE: "(BEC) 小學常識科：科學教育",
      TECHNOLOGY: "(BEC) 小學常識科：科技教育",
      ARTS: "(BEC) 藝術教育",
      PE: "(BEC) 體育",
      CIVIC: "(BEC) 德育及公民教育",
      READING: "(BEC) 從閱讀中學習",
    },
    SENIOR: {
      CHINESE: "(SSC) 中國語文教育",
      ENGLISH: "(SSC) 英國語文教育",
      MATHS: "(SSC) 數學教育",
      BIOLOGY: "(SSC) 科學教育：生物",
      CHEMISTRY: "(SSC) 科學教育：化學",
      PHYSICS: "(SSC) 科學教育：物理",
      IS: "(SSC) 科學教育：綜合科學",
      CS: "(SSC) 科學教育：組合科學",
      TECHNOLOGY: "(SSC) 科技教育",
      BUSINESS: "(SSC) 科技教育：企業、會計與財務概論",
      CHINESE_HISTORY: "(SSC) 個人、社會及人文教育：中國歷史",
      ECONOMICS: "(SSC) 個人、社會及人文教育：經濟",
      RELIGION: "(SSC) 個人、社會及人文教育：宗教教育 /倫理與宗教",
      GEOGRAPHY: "(SSC) 個人、社會及人文教育：地理",
      HISTORY: "(SSC) 個人、社會及人文教育：歷史與文化 / 歷史",
      SOCIETY: "(SSC) 個人、社會及人文教育：生活與社會",
      HUMANITIES: "(SSC) 個人、社會及人文教育：綜合人文",
      TOURISM: "(SSC) 個人、社會及人文教育：旅遊與旅遊業",
      MUSIC: "(SSC) 藝術教育：音樂",
      ARTS: "(SSC) 藝術教育：視覺藝術",
      PE: "(SSC) 體育",
      LIBERAL: "(SSC) 通識教育科",
      READING: "(SSC) 從閱讀中學習",
      OTHERS: "(SSC) 其他學習經歷",
      APPLIED: "(SSC) 應用學習",
    },
    BASIC_ID: {
      CHINESE: "(ID: BEC) 中國語文",
      MATHS: "(ID: BEC) 數學",
      GENERAL: "(ID: BEC) 常識",
      TECHNOLOGY: "(ID: BEC) 科技教育",
      APPLIED: "(ID: BEC) 應用學習調適課程",
    },
    SENIOR_ID: {
      CHINESE: "(ID: SSC) 中國語文",
      MATHS: "(ID: SSC) 數學",
      LIBERAL: "(ID: SSC) 通識教育/獨立生活",
      PE: "(ID: SSC) 體育",
      ARTS: "(ID: SSC) 視覺藝術",
      IT: "(ID: SSC) 資訊及通訊科技",
      TECHNOLOGY: "(ID: SSC) 科技與生活",
      MUSIC: "(ID: SSC) 音樂",
      DESIGN: "(ID: SSC) 設計與應用科技",
      RELIGION: "(ID: SSC) 倫理與宗教",
      HEALTH: "(ID: SSC) 健康管理與社會關懷",
      APPLIED: "(ID: SSC) 應用學習調適課程",
    },
  },
};
